import CircularProgress from '@mui/material/CircularProgress';

function MyLoading() {
  return (
    <div>
      <CircularProgress sx={{ color: 'black' }} thickness={4} size={30} />
    </div>
  );
}

export default MyLoading;
